export default function IconArrowRight() {
  return (
    <svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.0238 9.09375L1.96875 1.03875" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M10.0251 9.09406L2.08008 17.0391" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
